import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Twitter, Mail, Phone, MapPin, ArrowUpRight } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-950 text-white relative overflow-hidden" data-id="element-23">
      {/* Subtle decorative accents */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gold-500/5 rounded-full blur-3xl translate-x-1/2 -translate-y-1/2" data-id="element-24" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12" data-id="element-25">
        {/* Top CTA strip */}
        <div className="py-16 border-b border-white/10" data-id="element-26">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center" data-id="element-27">
            <div className="lg:col-span-7" data-id="element-28">
              <div className="flex items-center gap-3 mb-4" data-id="element-29">
                <div className="w-10 h-px bg-gold-500" data-id="element-30" />
                <span className="text-gold-500 font-semibold tracking-[0.25em] uppercase text-xs" data-id="element-31">
                  Begin a Conversation
                </span>
              </div>
              <h3 className="text-3xl md:text-4xl font-serif font-bold leading-tight" data-id="element-32">
                Considering your next critical hire?
                <span className="block text-gold-500 italic mt-1" data-id="element-33">
                  Let's talk.
                </span>
              </h3>
            </div>
            <div className="lg:col-span-5 lg:text-right" data-id="element-34">
              <a href="mailto:contact@talentbridge.blog" className="inline-flex items-center gap-3 group" data-id="element-35">
                <span className="text-2xl md:text-3xl font-serif text-white group-hover:text-gold-500 transition-colors" data-id="element-36">
                  Request a consultation
                </span>
                <div className="w-12 h-12 rounded-full border border-white/30 flex items-center justify-center group-hover:bg-gold-500 group-hover:border-gold-500 transition-all" data-id="element-37">
                  <ArrowUpRight className="h-5 w-5" data-id="element-38" />
                </div>
              </a>
            </div>
          </div>
        </div>

        {/* Main grid */}
        <div className="py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12" data-id="element-39">
          {/* Brand block */}
          <div className="lg:col-span-4" data-id="element-40">
            <Link to="/" className="flex items-center gap-4 mb-6" data-id="element-41">
              <div className="w-14 h-14 rounded-full bg-white/10 border border-gold-500/40 flex items-center justify-center" data-id="element-42">
                <span className="text-gold-500 font-serif font-bold text-base" data-id="element-43">
                  TB
                </span>
              </div>
              <div data-id="element-44">
                <div className="text-xl font-serif font-bold tracking-wide" data-id="element-45">
                  TalentBridge
                </div>
                <div className="text-xs font-medium tracking-[0.2em] uppercase text-gold-500" data-id="element-46">
                  Global
                </div>
              </div>
            </Link>
            <p className="text-gray-400 leading-relaxed mb-8 text-sm" data-id="element-47">
              A global executive search and leadership advisory firm. We help
              boards, CEOs, and investors secure transformative leadership
              talent across 42 markets worldwide.
            </p>
            <div className="flex items-center gap-3" data-id="element-48">
              <a href="#" aria-label="LinkedIn" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-gray-400 hover:bg-gold-500 hover:text-navy-900 hover:border-gold-500 transition-all" data-id="element-49">
                <Linkedin className="h-4 w-4" data-id="element-50" />
              </a>
              <a href="#" aria-label="Twitter" className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center text-gray-400 hover:bg-gold-500 hover:text-navy-900 hover:border-gold-500 transition-all" data-id="element-51">
                <Twitter className="h-4 w-4" data-id="element-52" />
              </a>
            </div>
          </div>

          {/* Practices */}
          <div className="lg:col-span-2" data-id="element-53">
            <h4 className="text-xs uppercase tracking-[0.25em] text-gold-500 font-semibold mb-6" data-id="element-54">
              Practices
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-55">
              <li data-id="element-56">
                <Link to="/services" className="text-gray-300 hover:text-white transition-colors" data-id="element-57">
                  Executive Search
                </Link>
              </li>
              <li data-id="element-58">
                <Link to="/services" className="text-gray-300 hover:text-white transition-colors" data-id="element-59">
                  Board Recruitment
                </Link>
              </li>
              <li data-id="element-60">
                <Link to="/services" className="text-gray-300 hover:text-white transition-colors" data-id="element-61">
                  Leadership Advisory
                </Link>
              </li>
              <li data-id="element-62">
                <Link to="/services" className="text-gray-300 hover:text-white transition-colors" data-id="element-63">
                  CEO Succession
                </Link>
              </li>
              <li data-id="element-64">
                <Link to="/services" className="text-gray-300 hover:text-white transition-colors" data-id="element-65">
                  Talent Acquisition Consulting
                </Link>
              </li>
            </ul>
          </div>

          {/* Firm */}
          <div className="lg:col-span-2" data-id="element-66">
            <h4 className="text-xs uppercase tracking-[0.25em] text-gold-500 font-semibold mb-6" data-id="element-67">
              The Firm
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-68">
              <li data-id="element-69">
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors" data-id="element-70">
                  About
                </Link>
              </li>
              <li data-id="element-71">
                <Link to="/about#team" className="text-gray-300 hover:text-white transition-colors" data-id="element-72">
                  Leadership Team
                </Link>
              </li>
              <li data-id="element-73">
                <Link to="/how-it-works" className="text-gray-300 hover:text-white transition-colors" data-id="element-74">
                  Our Process
                </Link>
              </li>
              <li data-id="element-75">
                <Link to="/testimonials" className="text-gray-300 hover:text-white transition-colors" data-id="element-76">
                  Client Stories
                </Link>
              </li>
              <li data-id="element-77">
                <Link to="/blog" className="text-gray-300 hover:text-white transition-colors" data-id="element-78">
                  Insights
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="lg:col-span-4" data-id="element-79">
            <h4 className="text-xs uppercase tracking-[0.25em] text-gold-500 font-semibold mb-6" data-id="element-80">
              Contact
            </h4>
            <ul className="space-y-5" data-id="element-81">
              <li className="flex items-start gap-3" data-id="element-82">
                <MapPin className="h-5 w-5 text-gold-500 mt-0.5 flex-shrink-0" data-id="element-83" />
                <div className="text-sm" data-id="element-84">
                  <div className="text-white font-semibold mb-1" data-id="element-85">
                    Global Headquarters
                  </div>
                  <div className="text-gray-400 leading-relaxed" data-id="element-86">
                    357 7th Ave, 2nd Floor
                    <br data-id="element-87" />
                    New York, NY 10001, United States
                  </div>
                </div>
              </li>
              <li className="flex items-center gap-3" data-id="element-88">
                <Phone className="h-5 w-5 text-gold-500 flex-shrink-0" data-id="element-89" />
                <a href="tel:+16788073391" className="text-gray-300 hover:text-white transition-colors text-sm" data-id="element-90">
                  +1 (678) 807-3391
                </a>
              </li>
              <li className="flex items-center gap-3" data-id="element-91">
                <Mail className="h-5 w-5 text-gold-500 flex-shrink-0" data-id="element-92" />
                <a href="mailto:contact@talentbridge.blog" className="text-gray-300 hover:text-white transition-colors text-sm" data-id="element-93">
                  contact@talentbridge.blog
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Office strip */}
        <div className="py-8 border-t border-white/10" data-id="element-94">
          <div className="grid grid-cols-2 md:grid-cols-6 gap-6 text-xs" data-id="element-95">
            {[{
            city: 'New York',
            label: 'Global HQ'
          }, {
            city: 'London',
            label: 'Europe'
          }, {
            city: 'Singapore',
            label: 'Asia Pacific'
          }, {
            city: 'Dubai',
            label: 'Middle East'
          }, {
            city: 'São Paulo',
            label: 'Latin America'
          }, {
            city: 'Johannesburg',
            label: 'Africa'
          }].map((office, i) => <div key={i} data-id="element-96">
                <div className="text-white font-semibold" data-id="element-97">{office.city}</div>
                <div className="text-gray-500 uppercase tracking-widest text-[10px] mt-1" data-id="element-98">
                  {office.label}
                </div>
              </div>)}
          </div>
        </div>

        {/* Bottom bar */}
        <div className="py-6 border-t border-white/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-xs text-gray-500" data-id="element-99">
          <p data-id="element-100">
            &copy; {new Date().getFullYear()} TalentBridge Global. All rights
            reserved. An AESC member firm.
          </p>
          <div className="flex gap-8" data-id="element-101">
            <a href="#" className="hover:text-white transition-colors" data-id="element-102">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-103">
              Terms of Service
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-104">
              Modern Slavery Statement
            </a>
          </div>
        </div>
      </div>
    </footer>;
}